import { Box, alpha } from '@mui/material';

import { HorizontalCarousel, SizingMultiplier } from '@ocx/ui';

import { CategoryPill } from '../category-pill/category-pill.component';
import { CategorySelectorProps } from './category-selector.types';
import { SPACING_BETWEEN_CATEGORIES } from './category-selector.constants';

export const CategorySelector = ({
  onCategoryChange,
  categories,
  selectedCategory,
  isSticky = false,
}: CategorySelectorProps) => {
  return (
    <Box
      sx={{
        background: (theme) =>
          `linear-gradient(0deg, ${alpha(theme.palette.background.default, 0)} 0%, ${alpha(
            theme.palette.background.default,
            0.96,
          )} 37%)`,
        ...(isSticky && {
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }),
      }}
      py={SizingMultiplier.sm}>
      <HorizontalCarousel spacing={SPACING_BETWEEN_CATEGORIES}>
        {categories.map(({ id, title }) => {
          const isSelected = selectedCategory ? selectedCategory.id === id : false;
          return (
            <CategoryPill key={id} isSelected={isSelected} onClick={() => onCategoryChange(id)}>
              {title}
            </CategoryPill>
          );
        })}
      </HorizontalCarousel>
    </Box>
  );
};
